/*
  assets/customer-result-history-family-checklists.js — FAMILY-RECORD-CHECKLIST-V5
  Owner: existing local-private Family notice detail/checklist enrichment on /pages/result-history.
  Data owner: window.LittleGFamilyData.listRecords(). No direct storage-key access.
  Locale owner: window.LITTLEG_LOCALE.
*/
(function familyChecklistRecords(window, document) {
  'use strict';

  var VERSION = 'FAMILY-RECORD-CHECKLIST-V5';
  var ROOT_SELECTOR = '[data-customer-result-history]';
  /** @type {Set<DirectoryRoot>} */
  const mountedRoots = new Set();
  var stateByRoot = new WeakMap();

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function array(value) {
    return Array.isArray(value) ? value : [];
  }

  function boolean(value) {
    var normalized = clean(value).toLowerCase();
    return (
      value === true ||
      value === 1 ||
      value === '1' ||
      normalized === 'true' ||
      normalized === 'yes' ||
      normalized === 'done' ||
      normalized === 'completed'
    );
  }

  function first() {
    for (var index = 0; index < arguments.length; index += 1) {
      var value = arguments[index];
      if (value !== undefined && value !== null && clean(value)) return clean(value);
    }
    return '';
  }

  function recordId(record, index) {
    return (
      clean(
        record &&
          (record.record_id || record.result_id || record.card_id || record.job_id || record.id)
      ) || 'record-' + index
    );
  }

  function locale(root) {
    var owner = window.LITTLEG_LOCALE;
    if (owner && typeof owner.getCode === 'function') {
      var owned = clean(owner.getCode()).replace(/_/g, '-');
      if (owned) {
        var ownedLower = owned.toLowerCase();
        if (
          ownedLower.indexOf('zh-cn') === 0 ||
          ownedLower.indexOf('zh-sg') === 0 ||
          ownedLower.indexOf('hans') !== -1
        )
          return 'zh-CN';
        if (ownedLower.indexOf('zh-tw') === 0) return 'zh-TW';
        if (ownedLower.indexOf('zh') === 0 || ownedLower.indexOf('hant') !== -1) return 'zh-HK';
        if (ownedLower.indexOf('en') === 0) return 'en';
      }
    }

    var raw = clean(
      (root && root.getAttribute('data-locale')) || document.documentElement.lang || 'zh-HK'
    )
      .replace(/_/g, '-')
      .toLowerCase();

    if (raw.indexOf('zh-cn') === 0 || raw.indexOf('zh-sg') === 0 || raw.indexOf('hans') !== -1)
      return 'zh-CN';
    if (raw.indexOf('zh-tw') === 0) return 'zh-TW';
    if (raw.indexOf('zh') === 0 || raw.indexOf('hant') !== -1) return 'zh-HK';
    if (raw.indexOf('en') === 0) return 'en';
    return 'zh-HK';
  }

  function copy(root, traditional, simplified, english, taiwan) {
    var code = locale(root);
    if (code === 'en') return english;
    if (code === 'zh-CN') return simplified;
    if (code === 'zh-TW') return taiwan || traditional;
    return traditional;
  }

  function recordsResult() {
    var owner = window.LittleGFamilyData;
    if (!owner || typeof owner.listRecords !== 'function') {
      return { available: false, records: [] };
    }

    try {
      var value = owner.listRecords();
      if (value && typeof value.then === 'function') {
        return { available: false, records: [] };
      }
      if (Array.isArray(value)) return { available: true, records: value };
      if (value && Array.isArray(value.records)) return { available: true, records: value.records };
      if (value && Array.isArray(value.items)) return { available: true, records: value.items };
      return { available: true, records: [] };
    } catch (_error) {
      return { available: false, records: [] };
    }
  }

  function fieldValue(notice, keys) {
    var fields = array(notice && notice.fields);
    var normalizedKeys = keys.map(function (key) {
      return clean(key).toLowerCase();
    });

    for (var index = 0; index < normalizedKeys.length; index += 1) {
      var field = fields.find(function (candidate) {
        return (
          candidate &&
          clean(candidate.key || candidate.name).toLowerCase() === normalizedKeys[index] &&
          clean(candidate.guardian_state).toLowerCase() !== 'removed'
        );
      });
      if (field) return clean(field.value || field.text);
    }

    return '';
  }

  function normalizeChecklistItem(item, index, group) {
    if (typeof item === 'string') {
      return {
        id: group + '-' + index,
        name: clean(item),
        checked: false,
      };
    }

    var source = item && typeof item === 'object' ? item : {};
    return {
      id: first(source.id, source.item_id, source.key, group + '-' + index),
      name: first(source.name, source.label, source.text, source.value, source.item),
      checked: boolean(first(source.checked, source.done, source.completed, source.is_checked)),
    };
  }

  function checklistModels(record) {
    var direct = array(record && record.checklist)
      .map(function (item, index) {
        return normalizeChecklistItem(item, index, 'checklist');
      })
      .filter(function (item) {
        return item.name;
      });

    if (direct.length) return direct;

    var packing =
      record && record.packing_list && typeof record.packing_list === 'object'
        ? record.packing_list
        : {};
    var groups = ['required_items', 'suggested_items', 'custom_items'];
    var output = [];

    groups.forEach(function (group) {
      array(packing[group]).forEach(function (item, index) {
        var model = normalizeChecklistItem(item, index, group);
        if (model.name) output.push(model);
      });
    });

    return output;
  }

  function deadlineModels(root, notice) {
    var values = array(notice && notice.deadlines)
      .map(function (item) {
        if (typeof item === 'string') {
          return {
            kind: 'reply',
            label: copy(root, '期限', '期限', 'Deadline'),
            due_at: clean(item),
          };
        }

        return {
          kind: clean(item && (item.kind || item.type)).toLowerCase() || 'reply',
          label: clean(item && item.label),
          due_at: clean(item && (item.due_at || item.deadline || item.value)),
        };
      })
      .filter(function (item) {
        return item.due_at;
      });

    var reply = fieldValue(notice, ['reply_deadline', 'reply_slip_deadline', 'response_deadline']);
    var payment = fieldValue(notice, ['payment_deadline', 'fee_deadline']);

    if (
      reply &&
      !values.some(function (item) {
        return item.kind === 'reply';
      })
    ) {
      values.push({
        kind: 'reply',
        label: copy(root, '回條／回覆期限', '回条／回复期限', 'Reply deadline'),
        due_at: reply,
      });
    }

    if (
      payment &&
      !values.some(function (item) {
        return item.kind === 'payment';
      })
    ) {
      values.push({
        kind: 'payment',
        label: copy(root, '付款期限', '付款期限', 'Payment deadline'),
        due_at: payment,
      });
    }

    return values;
  }

  function dateOnly(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(clean(value));
    if (!match) return null;

    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var date = new Date(year, month - 1, day, 12, 0, 0, 0);

    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      return null;
    }

    return date;
  }

  function formatDate(root, value) {
    var raw = clean(value);
    if (!raw) return '—';

    var date = dateOnly(raw) || new Date(raw);
    if (Number.isNaN(date.getTime())) return raw;

    var owner = window.LITTLEG_LOCALE;
    if (owner) {
      if (dateOnly(raw) && typeof owner.formatDate === 'function') return owner.formatDate(date);
      if (typeof owner.formatDateTime === 'function') return owner.formatDateTime(date);
    }

    try {
      var options = dateOnly(raw)
        ? { timeZone: 'Asia/Hong_Kong', year: 'numeric', month: 'short', day: 'numeric' }
        : {
            timeZone: 'Asia/Hong_Kong',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          };
      return new Intl.DateTimeFormat(locale(root), options).format(date);
    } catch (_error) {
      return raw;
    }
  }

  function create(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
  }

  function clearCardEnrichment(card) {
    if (!card) return;

    var existing = card.querySelector('[data-family-record-details]');
    if (existing) existing.remove();
  }

  function enrichCard(root, card, record) {
    if (!card) return false;

    clearCardEnrichment(card);
    if (!record) return false;

    var notice = record.notice && typeof record.notice === 'object' ? record.notice : {};
    var child =
      notice.child && typeof notice.child === 'object'
        ? notice.child
        : record.child && typeof record.child === 'object'
          ? record.child
          : record.child_profile && typeof record.child_profile === 'object'
            ? record.child_profile
            : {};
    var checklist = checklistModels(record);
    var deadlines = deadlineModels(root, notice);
    var checked = checklist.filter(function (item) {
      return item && boolean(item.checked);
    }).length;

    var details = create('details', 'customer-result-history__family-details');
    details.setAttribute('data-family-record-details', '');

    var summary = create(
      'summary',
      '',
      copy(
        root,
        '查看孩子、期限與 Checklist',
        '查看孩子、期限和 Checklist',
        'View child, deadlines, and checklist'
      )
    );

    var meta = create('div', 'customer-result-history__family-meta');
    meta.appendChild(
      create(
        'p',
        '',
        copy(root, '孩子：', '孩子：', 'Child: ') +
          (first(child.nickname_snapshot, child.nickname, child.name) ||
            copy(root, '未指定孩子', '未指定孩子', 'No child selected'))
      )
    );
    meta.appendChild(
      create(
        'p',
        '',
        copy(root, '準備進度：', '准备进度：', 'Preparation progress: ') +
          checked +
          '／' +
          checklist.length
      )
    );

    deadlines.forEach(function (deadline) {
      var fallback =
        deadline.kind === 'payment'
          ? copy(root, '付款期限', '付款期限', 'Payment deadline')
          : copy(root, '回條／回覆期限', '回条／回复期限', 'Reply deadline');
      meta.appendChild(
        create('p', '', (deadline.label || fallback) + '：' + formatDate(root, deadline.due_at))
      );
    });

    if (window.navigator.onLine === false) {
      meta.appendChild(
        create(
          'span',
          'customer-result-history__offline-badge',
          copy(
            root,
            '離線讀取 · 本機私人記錄',
            '离线读取 · 本机私人记录',
            'Offline · Private local record'
          )
        )
      );
    }

    var list = create('ul', 'customer-result-history__checklist');
    list.setAttribute('data-record-checklist', '');

    if (!checklist.length) {
      var empty = create(
        'li',
        '',
        copy(
          root,
          '此記錄沒有 Checklist 項目。',
          '此记录没有 Checklist 项目。',
          'This record has no checklist items.'
        )
      );
      empty.setAttribute('data-checklist-empty', 'true');
      list.appendChild(empty);
    } else {
      checklist.forEach(function (item) {
        var row = create(
          'li',
          '',
          item.name || copy(root, '未命名項目', '未命名项目', 'Unnamed item')
        );
        row.setAttribute('data-checked', boolean(item.checked) ? 'true' : 'false');
        row.setAttribute('data-checklist-item-id', clean(item.id));
        list.appendChild(row);
      });
    }

    details.append(summary, meta, list);
    var actions = card.querySelector('.customer-result-history__card-actions');
    card.insertBefore(details, actions || null);
    return true;
  }

  function render(root) {
    if (!root || !root.isConnected) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-record-type="family"]'));
    var result = recordsResult();

    if (!result.available) {
      cards.forEach(clearCardEnrichment);
      root.setAttribute('data-offline-family-checklists', 'owner-unavailable');
      root.setAttribute('data-family-checklist-rendered-count', '0');
      return;
    }

    var map = Object.create(null);
    result.records.forEach(function (record, index) {
      map[recordId(record, index)] = record;
    });

    var rendered = 0;
    cards.forEach(function (card) {
      var record = map[clean(card.getAttribute('data-record-id'))];
      if (enrichCard(root, card, record)) rendered += 1;
    });

    root.setAttribute('data-offline-family-checklists', 'ready');
    root.setAttribute('data-family-checklist-rendered-count', String(rendered));
  }

  function schedule(root) {
    var state = stateByRoot.get(root);
    if (!state || state.raf != null) return;

    state.raf = window.requestAnimationFrame(function () {
      state.raf = null;
      render(root);
    });
  }

  function mount(root) {
    if (!root || stateByRoot.has(root)) return;

    var state = {
      raf: null,
      observer: null,
    };
    stateByRoot.set(root, state);
    mountedRoots.add(root);
    root.setAttribute('data-family-checklist-bound', VERSION);

    var grid = root.querySelector('[data-family-record-grid]');
    if (grid && typeof MutationObserver === 'function') {
      state.observer = new MutationObserver(function () {
        schedule(root);
      });
      state.observer.observe(grid, { childList: true });
    }

    schedule(root);
  }

  function destroy(root) {
    var state = root ? stateByRoot.get(root) : null;
    if (!state) return;

    if (state.raf != null) window.cancelAnimationFrame(state.raf);
    if (state.observer) state.observer.disconnect();

    mountedRoots.delete(root);
    stateByRoot.delete(root);
    root.removeAttribute('data-family-checklist-bound');
    root.removeAttribute('data-offline-family-checklists');
    root.removeAttribute('data-family-checklist-rendered-count');
  }

  function mountAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) mount(target);
    if (!target.querySelectorAll) return;
    Array.prototype.forEach.call(target.querySelectorAll(ROOT_SELECTOR), mount);
  }

  function destroyAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) destroy(target);
    if (!target.querySelectorAll) return;
    Array.prototype.forEach.call(target.querySelectorAll(ROOT_SELECTOR), destroy);
  }

  function refreshAll() {
    mountedRoots.forEach(function (root) {
      schedule(root);
    });
  }

  window.addEventListener('online', refreshAll);
  window.addEventListener('offline', refreshAll);
  window.addEventListener('pageshow', refreshAll);
  window.addEventListener('storage', refreshAll);
  document.addEventListener('littleg:family-data-ready', refreshAll);
  document.addEventListener('littleg:family-record-saved', refreshAll);
  document.addEventListener('littleg:locale-ready', refreshAll);
  document.addEventListener('shopify:section:load', function (event) {
    mountAll(event && event.target ? event.target : document);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event && event.target ? event.target : document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        mountAll(document);
      },
      { once: true }
    );
  } else {
    mountAll(document);
  }
})(window, document);
